import DealerRewardListTable from './dealerRewardListTable.container';

export default DealerRewardListTable